import React from "react";
import Link from "next/link";
import styled from "styled-components";
import { Button, Heading, Stack } from "@kiwicom/orbit-components";
import { hasScopeFromToken } from "../helpers/hasScope";
import { LINKS } from "./links";
import { LoginScope, useVerifyQuery } from "../generated/graphql";
import getAuthorization from "../helpers/getAuthorization";
import Loading from "@kiwicom/orbit-components/lib/Loading";
import { useRouter } from "next/router";

interface SignPostProps {
  isExport: boolean;
}

export interface IAppContext {
  token?: string;
}

const SignPostItem = styled.a`
  padding: ${({ theme }) => theme.orbit.spaceMedium};
  background: ${({ theme }) => theme.orbit.backgroundCard};
  display: block;
  flex: 1;
  max-width: 320px;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.orbit.borderColorCard};
`;

export const SignPost = ({ isExport }: SignPostProps) => {
  const authorization = getAuthorization();

  const router = useRouter();

  const { loading } = useVerifyQuery({
    variables: {
      token: authorization.token
    },
    skip: !authorization.token,
    onError: async () => {
      await router.push("/login");
    }
  });

  function renderContent() {
    return (
      <Stack
        desktop={{
          direction: "row",
          justify: "center",
          spacing: "XXLarge"
        }}
        align="center"
        direction="column"
      >
        <Link href={LINKS.contractPrivate(isExport)} passHref>
          <SignPostItem>
            <Stack direction="column" spacing="XXLarge" align="center">
              <Heading type="title2">Distribuční smlouva</Heading>
              <Button asComponent="a" fullWidth>
                Začít vyplňovat
              </Button>
            </Stack>
          </SignPostItem>
        </Link>
        {hasScopeFromToken(authorization.token, LoginScope.Tesla) && (
          <Link href={LINKS.contractTesla(isExport)} passHref>
            <SignPostItem>
              <Stack direction="column" spacing="XXLarge" align="center">
                <Heading type="title2">ATRIS smlouva</Heading>
                <Button asComponent="a" fullWidth>
                  Začít vyplňovat
                </Button>
              </Stack>
            </SignPostItem>
          </Link>
        )}
      </Stack>
    );
  }

  return loading ? <Loading /> : renderContent();
};
